import actions from './actions'
import mutations from './mutations'
import getters from './getters'
const state = {
  storeList: [],
  storeName: {},
  storeNo: '',
  accessToken: '',
  operatorNo: '',
  merchant: {},
  loginName: '',
  sideCount: {},
  businessStatus: '',
  prepareStatus: '',
  autoOrder: false

}

export default {
  state,
  actions,
  getters,
  mutations
}
